module.exports = __webpack_public_path__ + "static/media/python.2ac57619.jpg";